import { OptionType } from "@qendo/types";
import { Link, useLocalSearchParams } from "expo-router";
import { DataList } from "~/components/layout/DataList";
import { DataListItem } from "~/components/layout/DataListItem";
import { FullPageModal } from "~/components/layout/modal/FullPageModal";
import { Title } from "~/components/layout/text";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useOptions } from "~/providers/OptionsProvider";
import { useProfile } from "~/providers/ProfileProvider";
import { filled } from "~/util";

export default function ShowContact() {
    const { contact_id }: { contact_id: string } = useLocalSearchParams();
    const { contacts } = useProfile();
    const { handleDismiss } = useDismiss();
    const contact = contacts.find(({ id }) => id === contact_id);
    const { findOption } = useOptions();

    const option = findOption(OptionType.team_members, contact?.option_id);

    if (!contact?.emergency_contact) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="view" section="profile">
            <FullPageModal title="Contact Details" onRequestClose={handleDismiss} withDone asRoute>
                <Title>{contact.name}</Title>
                <DataList>
                    {filled(option) && <DataListItem title="Relationship" data={option.title} />}
                    {filled(contact.email) && (
                        <DataListItem title="Email">
                            <Link href={`mailto:${contact.email}`}>{contact.email}</Link>
                        </DataListItem>
                    )}
                    {filled(contact.phone) && (
                        <DataListItem title="Phone">
                            <Link href={`tel:${contact.phone}`}>{contact.phone}</Link>
                        </DataListItem>
                    )}
                </DataList>
            </FullPageModal>
        </Authorize>
    );
}
